import React from "react";

const FontSizeControls = () => {
  // Function to increase font size
  function increaseFontSize() {
    const elements = document.querySelectorAll(
      "h1, div, section, p, ul, li, h4, h3, h5, span, a" 
    );
    elements.forEach((el) => {
      const currentFontSize = parseFloat(window.getComputedStyle(el).fontSize);
      // el.style.fontSize = `${currentFontSize + 1}px`;
      if (currentFontSize < 28) {
        el.style.fontSize = `${currentFontSize + 1}px`;
      }
    });
  }

  // Function to decrease font size
  function decreaseFontSize() {
    const elements = document.querySelectorAll(
      "h1, div, section, p, ul, li, h4, h3, h5, span, a"
    );
    elements.forEach((el) => {
      const currentFontSize = parseFloat(window.getComputedStyle(el).fontSize);
      el.style.fontSize = `${Math.max(currentFontSize - 1, 1)}px`;
    });
  }

  // Function to reset font size
  function resetFontSize() {
    const elements = document.querySelectorAll(
      "h1, div, section, p, ul, li, h4, h3, h5, span, a"
    );
    elements.forEach((el) => {
      el.style.fontSize = "";
    });
  }

  return (
    <li className="text-size">
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          decreaseFontSize();
        }}
      >
        A-
      </a>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          resetFontSize();
        }}
      >
        A
      </a>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          increaseFontSize();
        }}
      >
        A+
      </a>
    </li>
  );
};

export default FontSizeControls;
